// extracted by mini-css-extract-plugin
export default {"Bluecheese":"#615CFF","Oyster":"#C0C5C9","link":"Ged9b7f","icon":"G3b4339","label":"G1e7857 Geaabd4 G46a5ea"};